module.exports = __webpack_public_path__ + "static/media/creditor-profile.6c70cfbe.svg";